import { addUnit, editUnit } from "../../../api/unit/unit";
import { getUsers } from "../../../api/admin/user";
import { AddUpperUnit } from ".";
import { Button } from "../../Button";
import { CloseBtn } from "../../CloseBtn";
import { Col, Row } from "react-grid-system";
import { DatePicker } from "../../DatePicker";
import { Select } from "../../Select";
import { Field, Form, Formik } from "formik";
import { Link } from "react-router-dom";
import { StyledField } from "../../../styles/StyledField";
import { StyledModal, StyledNonScrollableModal } from "../../../styles/StyledModal";
import { StyledUnitActions } from "../../../styles/StyledUnit";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { useUnitContext } from "../../../context/unitContext";
import CloseIcon from "../../../assets/img/icons/close.svg";
import EditIcon from "../../../assets/img/icons/edit.svg";
import Modal from "react-modal";
import ModalHeader from "../../ModalHeader/ModalHeader";
import moment from "moment";
import PropTypes from "prop-types";
import SaveIcon from "../../../assets/img/icons/save.svg";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function UnitHeaderEdit({ edit, newUnit, disableEditingMode, refetch }) {
	const navigate = useNavigate();
	const { axiosPrivate } = useAxiosPrivate();

	const { id, name, startDate, endDate, parent } = useUnitContext();

	const [modalIsOpen, setIsOpen] = useState(false);
	const [selectedUpperUnit, setSelectedUpperUnit] = useState(parent ? parent : null);

	// A new unit is created together with its unit admin (any active user of the organization)
	const { data: users } = useQuery(["unitAdminCandidates"], () => getUsers(axiosPrivate, "", 1000), { enabled: !!newUnit });
	const adminOptions = (Array.isArray(users) ? users : [])
		.filter((user) => user.active !== false)
		.map((user) => ({ value: user.id, label: `${user.firstName} ${user.lastName} (${user.email})` }));

	useEffect(() => {
		Modal.setAppElement("body");
	});

	const initialValues = {
		name: name ? name : "",
		startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
		endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
		// The description of an existing unit is edited on its Overview tab
		...(newUnit ? { admin: null, description: "" } : {}),
	};

	const validate = (values) => (newUnit && !values.admin ? { admin: "A unit must have an admin" } : {});

	const submitHandler = (values) => {
		if (newUnit)
			addUnit(
				axiosPrivate,
				navigate,
				selectedUpperUnit ? { ...values, parent: parseInt(selectedUpperUnit.id) } : { ...values, parent: null }
			);
		if (!newUnit)
			editUnit(
				axiosPrivate,
				id,
				selectedUpperUnit ? { ...values, parent: parseInt(selectedUpperUnit.id) } : { ...values, parent: null },
				() => {
					disableEditingMode();
					refetch();
				}
			);
	};

	return (
		<>
			<Formik initialValues={initialValues} validate={validate} onSubmit={(values) => submitHandler(values)}>
				{({ values, errors, submitCount, setFieldValue }) => (
					<Form>
						<Row>
							<Col sm={5}>
								<StyledField mb="1rem">
									<label htmlFor="name">Name</label>
									<Field id="name" name="name" data-testid="name" />
								</StyledField>
								{newUnit && (
									<StyledField mb="1rem">
										<label>Unit admin</label>
										<Select
											options={adminOptions}
											value={values.admin}
											onChange={(name, value) => setFieldValue(name, value)}
											id="admin"
											name="admin"
											data-testid="admin"
										/>
										{errors.admin && submitCount > 0 ? <span>{errors.admin}</span> : null}
									</StyledField>
								)}
								{newUnit && (
									<StyledField edit small mb="1rem">
										<label htmlFor="description">Description</label>
										<Field as="textarea" id="description" name="description" data-testid="description" />
									</StyledField>
								)}
								<StyledField>
									<label>
										Upper unit
										{!selectedUpperUnit && (
											<Button bg={false} small={true} icon={EditIcon} initial onClick={() => setIsOpen(true)}>
												Add upper unit
											</Button>
										)}
									</label>
									{selectedUpperUnit && (
										<StyledField>
											<div className="wrapper">
												<span>{selectedUpperUnit.name}</span>
												<CloseBtn onClick={() => setSelectedUpperUnit(null)} icon={CloseIcon} small />
											</div>
										</StyledField>
									)}
								</StyledField>
							</Col>
							<Col sm={6} offset={{ sm: 1 }}>
								<Row>
									<Col sm={4} xl={3} xxxl={2}>
										<StyledField edit>
											<label>Start date</label>
											<DatePicker id="startDate" name="startDate" data-testid="startDate" autoComplete="off" />
										</StyledField>
									</Col>
									<Col sm={4} xl={3} xxxl={2}>
										<StyledField edit>
											<label>End date</label>
											<DatePicker id="endDate" name="endDate" data-testid="endDate" autoComplete="off" />
										</StyledField>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row>
							<Col sm={5}>
								<StyledUnitActions>
									{newUnit && <Link to="/">Cancel</Link>}
									{edit && (
										<Button onClick={disableEditingMode} bg={false} small={true}>
											Cancel
										</Button>
									)}
									<Button type="submit" icon={SaveIcon}>
										Save changes
									</Button>
								</StyledUnitActions>
							</Col>
						</Row>
					</Form>
				)}
			</Formik>
			<Modal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)} style={StyledNonScrollableModal} appElement={document.getElementById("app")}>
				<ModalHeader onClick={() => setIsOpen(false)}>Add upper unit</ModalHeader>
				<AddUpperUnit onClick={() => setIsOpen(false)} selectedUpperUnit={setSelectedUpperUnit} id={id} isNew={newUnit ? true : false} />
			</Modal>
		</>
	);
}

UnitHeaderEdit.propTypes = {
	data: PropTypes.object,
	disableEditingMode: PropTypes.func,
	refetch: PropTypes.func,
	edit: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	newUnit: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};
